import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { selectTeachersList } from 'modules/teachers/ducks/selectors'
import TeachersTableRow from 'modules/teachers/components/TeachersTableRow'
import Table from 'components/Table'
import Checkbox from 'components/Checkbox'
import { isNilOrEmpty, isNotNil, isNotNilOrEmpty } from 'utils/ramda'
import styled from 'styled-components'
import Input from 'components/Input'
import SearchIcon from '@mui/icons-material/Search'
import { isNil } from 'ramda'
import Button from 'components/Button'
import Modal from 'components/Modal'

const TeachersTable = ({ teachersList }) => {
  const allTeachers = useSelector(selectTeachersList)
  const list = isNotNil(teachersList) ? teachersList : allTeachers
  const [filtered, setFiltered] = useState(list)
  const [searchQuery, setSearchQuery] = useState('')
  const [selectedTeachers, setSelectedTeachers] = useState([])
  const [isPhoneNumbersModalOpen, setIsPhoneNumbersModalOpen] = useState(false)

  useEffect(() => {
    const query = searchQuery.toLowerCase().trim()
    const byLastName = list
      .map(teachers => ({ ...teachers, lastName: teachers.name.split(' ')[1] || '' }))
      .sort((a, b) => a.lastName.localeCompare(b.lastName))
    setFiltered(byLastName.filter(teacher => {
      const name = teacher.name.toLowerCase()
      const email = teacher.email.toLowerCase()
      return name.includes(query) || email.includes(query)
    }))
  }, [searchQuery, list])

  const handleSelectAll = (_, checked) => {
    if (checked) {
      setSelectedTeachers(filtered.map(teacher => teacher.id))
    } else {
      setSelectedTeachers([])
    }
  }

  const handleSelectTeacher = (teacherId, checked) => {
    if (checked) {
      setSelectedTeachers(prev => [...prev, teacherId])
    } else {
      setSelectedTeachers(prev => prev.filter(id => id !== teacherId))
    }
  }

  const isAllSelected = filtered.length > 0 && selectedTeachers.length === filtered.length

  const handlePhoneNumbersModalOpen = () => setIsPhoneNumbersModalOpen(true)
  const handlePhoneNumbersModalClose = () => setIsPhoneNumbersModalOpen(false)

  return (
    <>
      <HeaderWrapper>
        {
          isNil(teachersList) ? (
            <InputWrapper>
              <Input
                name='search'
                placeholder='Szukaj...'
                onChange={(_, value) => setSearchQuery(value)}
                value={searchQuery}
                startAdornment={<SearchIcon />}
              />
            </InputWrapper>
          ) : <div />
        }
        <ButtonWrapper>
          <Button color='primary' onClick={handlePhoneNumbersModalOpen} disabled={isNilOrEmpty(selectedTeachers)}>
            Pokaż numery telefonów
          </Button>
        </ButtonWrapper>
      </HeaderWrapper>
      <Table>
        <thead>
          <th>
            <CheckboxWrapper>
              <Checkbox
                value={isAllSelected}
                onChange={handleSelectAll}
              />
            </CheckboxWrapper>
          </th>
          <th>Lp.</th>
          <th>Nazwa</th>
          <th>Email</th>
          <th>Numer telefonu</th>
          <th />
        </thead>
        <tbody>
          {filtered.map((teacher, index) => (
            <TeachersTableRow
              order={index + 1}
              teacher={teacher}
              key={`teacher-${teacher.id}`}
              isSelected={selectedTeachers.includes(teacher.id)}
              onSelect={handleSelectTeacher}
            />
          ))}
        </tbody>
      </Table>
      {isNilOrEmpty(filtered) && (
        <EmptyState>
          Brak nauczycieli do wyświetlenia
        </EmptyState>
      )}
      <Modal
        title='Numery zaznaczonych nauczycieli'
        open={isPhoneNumbersModalOpen}
        onClose={handlePhoneNumbersModalClose}
      >
        {list
          .filter(teacher => selectedTeachers.includes(teacher.id) && isNotNilOrEmpty(teacher.phoneNumber))
          .map(teacher => teacher.phoneNumber)
          .join(';')}
      </Modal>
    </>
  )
}

export default TeachersTable

const EmptyState = styled.div`
  width: 100%;
  height: 70px;
  display: flex;
  align-items: center;
`

const InputWrapper = styled.div`
  display: flex;

  div {
    max-width: 300px;
  }
`

const CheckboxWrapper = styled.div`
  display: flex;
  justify-content: center;
`

const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const ButtonWrapper = styled.div`
  width: 200px;
`